/**
 * @name          jQuery Maps Plugin
 * @version       0.1
 * @lastmodified  2019-05-03
 * @package       html-css-js
 * @subpackage    jQuery plugin
 * @author        SM, VI, RL
 *
 * based on: http://jqueryboilerplate.com/
 */

(function($, window, document, undefined) {
	"use strict";

	var pluginName = "mapPlugin";

	var defaults = {
		zoom: 8,
		maxZoom: 16,

		mapStyles: global.configuration.get("global.mapStyles"),

		markerImage: global.configuration.get("global.markerImage"),
		markerImageSize: 48,
		markerImageCluster: global.configuration.get(
			"global.markerImageCluster"
		),
		markerImageClusterSize: 60,
		markerImageBHKW: global.configuration.get("global.markerImageBHKW"),
		markerImageBiene: global.configuration.get("global.markerImageBiene"),
		markerImageBiogas: global.configuration.get("global.markerImageBiogas"),
		markerImageIdea: global.configuration.get("global.markerImageIdea"),
		markerImageMapThin: global.configuration.get(
			"global.markerImageMapThin"
		),
		markerImageSolar: global.configuration.get("global.markerImageSolar"),
		markerImageSmartCity: global.configuration.get(
			"global.markerImageSmartCity"
		),
		markerImageWallbox: global.configuration.get(
			"global.markerImageWallbox"
		),
		markerImageWasser: global.configuration.get("global.markerImageWasser"),
		markerImageWasserwerk: global.configuration.get(
			"global.markerImageWasserwerk"
		),
		markerImageWind: global.configuration.get("global.markerImageWind"),
		markerImageWindConstruction: global.configuration.get(
			"global.markerImageWindConstruction"
		),
		markerImageWindPlanning: global.configuration.get(
			"global.markerImageWindPlanning"
		),

		clusterColor: global.configuration.data.global.mapsClusterColor,
		clusterImage:
			global.configuration.data.staticResourcesBase +
			global.configuration.get("global.mapsClusterImage"),
		clusterImageSize: 36,

		mapSelector: "#map"
	};

	function Plugin(element, options) {
		this.element = element;
		this.$element = $(element);
		this.options = $.extend({}, defaults, options);
		this.init();
	}

	var methods = {
		init: function() {
			this.$map = this.$element.find(this.options.mapSelector);
			this.$filters = this.$element.find("[data-filters]");
			this.map = null;
			this.markerClusterer = null;
			this.allMarkers = [];
			this.activeMarkers = [];
			this.activeMarker = null;
			this.infoWindow = null;
			this.categories = {};
			this.locations = [];
			this.filterCategories = [];
			this.activeFilterCategories = [];
			this.isFiltersExpanded = this.$filters.data(
				"is-initially-expanded"
			);
			this.zoom = this.$element.data("zoom") || this.options.zoom;
			this.maxZoom =
				this.$element.data("maxZoom") || this.options.maxZoom;

			this.getCategories();
			this.getData();
		},

		/**
		 * Each category is an object where the key is the category name and the
		 * boolean flag tells us whether the filter should be initially active
		 * or not.
		 *
		 * ```js
		 * 	[
		 * 		{ "innofonds": true},
		 * 		{ "solar": false },
		 * 		{ "windwheels": true },
		 * 		{ "smart-city": false }
		 * 	]
		 * ```
		 *
		 * We map it to the following data structure which is easier to work with.
		 *
		 * ```js
		 *	{
		 *		innofonds: true,
		 * 		solar: false,
		 * 		windwheels: true,
		 * 		smart-city: false
		 * 	}
		 * ```
		 */
		getCategories: function() {
			var self = this;
			var categories = this.$element.data("map-categories");

			categories.forEach(function(category) {
				for (var key in category) {
					self.categories[key] = category[key];
				}
			});
		},

		/**
		 * Some categories should be combined to a single category.
		 *
		 * badenova, bnnetze, badenovanetze, wasser, esdg, karriere, waerme --> badenova
		 */
		reassignCategories: function(category) {
			if (
				category === "badenova" ||
				category === "bnnetze" ||
				category === "badenovanetze" ||
				category === "wasser" ||
				category === "esdg" ||
				category === "waerme"
			) {
				return "organisation";
			} else {
				return category;
			}
		},

		/**
		 * Returns all active category names as strings.
		 * @return {string[]}
		 */
		getActiveCategoryNames: function() {
			var categoryNames = [];

			for (var key in this.categories) {
				if (this.categories[key]) {
					categoryNames.push(key);
				}
			}

			return categoryNames;
		},

		/**
		 * Each endpoint returns a json file. There are 6 in total when all
		 * requests succeed.
		 *
		 * Each top-level object has a category, a label, a menu icon, and all
		 * locations for that category.
		 *
		 * The label is the label of the filter.
		 *
		 * The menu icon indicates which map marker should be used.
		 *
		 * Note that, each endpoint returns all categories, but not all
		 * categories have locations associated with them.
		 *
		 * ```json
		 * 	[
		 *		{
		 *			"category": "innofonds",
		 *			"label": "Innovationsfonds",
		 *			"menuIcon": "idea",
		 *			"locations": [
		 *				{
		 *					"code": "in_65535_5",
		 *					"title": "Auf der Suche nach dem Guten Leben",
		 *					"description": "Bildungsparcours zur Nachhaltigkeit im Hanf-Labyrinth\n",
		 *					"image": "\/content-medien\/unternehmen\/engagement\/innovativ\/unternehmensbereiche\/stab\/vs-oeko-innovation\/innovationsfonds\/projekte-2019\/2019-01-hanffeld5_pic_240.jpg",
		 *					"external_url": "/ueber-uns/engagement/innovativ/innovationsfonds-projekte/auf-der-suche-nach-dem-guten-leben.jsp",
		 *					"linkRoute": "https://www.google.de/maps/place/Wilhelmstra%C3%9Fe+24,+79098+Freiburg+im+Breisgau/@47.9928613,7.8411656,17z/data=!3m1!4b1!4m5!3m4!1s0x47911b60201fc0a3:0x2452635db7660d5d!8m2!3d47.9928613!4d7.8433543",
		 *					"lat": "47.9928613",
		 *					"lng": "7.8411656"
		 *				}
		 *			]
		 *		}
		 *	]
		 * ```
		 */
		getData: function() {
			var self = this;
			var apiRequests = [];
			var endpoints = self.$element.data("map-source-endpoints");

			$.each(endpoints, function(_i, endpoint) {
				apiRequests.push(
					new Promise(function(resolve) {
						$.getJSON(endpoint)
							.done(function(res) {
								resolve(res);
							})
							.fail(function(xhr, _textStatus) {
								resolve(null);
							});
					})
				);
			});

			Promise.all(apiRequests).then(function(res) {
				if (res && Array.isArray(res)) {
					// Filter null values in case an API request failed
					var data = res.filter(function(jsonData) {
						return jsonData !== null;
					});

					$.each(data, function(i, endpointData) {
						$.each(endpointData, function(j, categoryItem) {
							$.each(categoryItem.locations, function(
								k,
								locationItem
							) {
								if (
									Object.keys(self.categories).indexOf(
										categoryItem.category
									) >= 0
								) {
									var location = locationItem;
									location.lat = parseFloat(locationItem.lat);
									location.lng = parseFloat(locationItem.lng);
									location.position = {
										lat: location.lat,
										lng: location.lng
									};
									location.category = self.reassignCategories(
										categoryItem.category
									);
									location.label = categoryItem.label;
									location.menuIcon = categoryItem.menuIcon;
									self.locations.push(location);
								}
							});
						});
					});

					self.mapDataIsReady = true;
					self.initFilters();
					self.initZoomButtons();
					self.initMap();
				} else {
					// TODO: Handle potential request errors
				}
			});
		},

		initMap: function() {
			var self = this;

			self.map = new google.maps.Map(self.$map.get(0), {
				zoom: self.zoom,
				maxZoom: self.maxZoom,
				scrollwheel: true,
				disableDefaultUI: true,
				styles: self.options.mapStyles
			});

			self.bounds = new google.maps.LatLngBounds();

			self.mapClickListener = self.map.addListener("click", function() {
				self.resetActiveMarker();
			});

			self.addMarkers();
			self.initSearchBarAutocomplete();

			// Handle mousewheel zoom out in case an infoWindow is open
			// and must be closed
			self.element.addEventListener("wheel", function(e) {
				var currentZoom = self.map.getZoom();
				var maxZoom = self.maxZoom;

				if (self.markerClusterer) {
					if (maxZoom !== null && currentZoom <= maxZoom) {
						if (self.activeMarker) {
							self.closeInfoWindow();
						}
					}
				}
			});

			google.maps.event.addListener(
				self.markerClusterer,
				"clusterclick",
				function(cluster) {
					var zoom = self.map.getZoom();
					var theBounds = cluster.getBounds();
					var markers = cluster.getMarkers();

					// Comment below is taken from source code!
					// "There is a fix for Issue 170 here"
					setTimeout(function() {
						self.map.fitBounds(theBounds);

						if (
							!self.markersAreOnSamePosition(markers) &&
							self.maxZoom !== null &&
							zoom < self.maxZoom
						) {
							self.map.setZoom(zoom + 2);
						} else {
							self.activeMarker = null;
							self.markerOrClusterOnClick(markers[0]);
						}
					}, 100);
				}
			);
		},

		containsCategory: function(categoryName, categories) {
			$.each(categories, function() {
				if (this.category === categoryName) {
					return true;
				}
			});

			return false;
		},

		filterMarkersByCategories: function(categories) {
			if (categories.length === 0) {
				return [];
			}

			return this.allMarkers.filter(function(marker) {
				return $.inArray(marker.data.category, categories) > -1;
			});
		},

		initFilters: function() {
			var self = this;
			var filterCategories = [];

			if (this.categories.length === 0) {
				this.$filters.hide();
				return;
			}

			// Create filter markup
			var html = "";
			var tempLocation;

			for (var key in this.categories) {
				var reassignCategory = self.reassignCategories(key);

				if (reassignCategory === "organisation") {
					if (this.categories[reassignCategory] !== true) {
						this.categories[reassignCategory] = this.categories[
							key
						];
					}
					delete this.categories[key];
				}
			}

			for (var category in this.categories) {
				tempLocation = $.grep(this.locations, function(location) {
					return location.category === category;
				})[0];

				if (tempLocation) {
					filterCategories.push({
						category: tempLocation.category,
						menuIcon: tempLocation.menuIcon,
						label: tempLocation.label,
						isActive: this.categories[category]
					});
				}
			}

			$.each(filterCategories, function(i, category) {
				html += global.configuration.data.tpl.mapsFilterItem(category);
			});

			self.$searchFilter = self.$filters.parent().prev("[data-search]");

			self.$filters.html(html);

			self.$filters.on("click", "li", function() {
				var category = $(this)
					.find("a")
					.data("filter");

				if (self.activeMarker) {
					self.closeInfoWindow();
				}

				if (self.categories[category]) {
					$(this).removeClass("is-active");
				} else {
					$(this).addClass("is-active");
				}

				self.categories[category] = !self.categories[category];

				self.removeMarkers();
				self.activeMarkers = self.filterMarkersByCategories(
					self.getActiveCategoryNames()
				);

				self.showMarkers(self.activeMarkers);
				self.updateMarkerClusterer(self.activeMarkers);

				if (self.getActiveCategoryNames().length > 0) {
					self.extendMapBound(
						self.getFilteredLocationsByCategories(
							self.getActiveCategoryNames()
						)
					);
					self.map.fitBounds(self.bounds);
					self.map.panTo(self.bounds.getCenter());
				}

				if (self.$searchFilter.hasClass("is-active")) {
					self.$searchFilter.removeClass("is-active");
				}
			});

			self.$searchFilter.on("click", function() {
				var $this = $(this);

				$this.addClass("is-active");
				$this.find('input[type="search"]').focus();
				$this.find("[data-close]").one("click", function(e) {
					// Don't let this click event bubble up, or it'd open the search bar again
					e.stopPropagation();
					e.preventDefault();

					$this.removeClass("is-active");
				});
			});

			// Initial sort
			self.$filters
				.find("li")
				.sort(function(a, _b) {
					if ($(a).hasClass("is-active")) {
						return -1;
					} else {
						return 1;
					}

					return 0;
				})
				.detach()
				.appendTo(self.$filters);

			if (self.getActiveCategoryNames() > 5) {
				self.$filters
					.find("li")
					.filter(function() {
						return !$(this).hasClass("is-active");
					})
					.addClass("hidden");
			}
			if (self.isFiltersExpanded) {
				self.$filters.addClass("locationMap__filters--isExpanded");
			}

			self.$filters
				.next("[data-filter-expander]")
				.on("click", function() {
					var $filters = self.$filters.find("li");

					var $inactiveFilters = $filters.filter(function() {
						return !$(this).hasClass("is-active");
					});

					if (self.activeFilterCategories > 5) {
						$inactiveFilters.toggleClass(
							"hidden",
							self.isFiltersExpanded
						);
					}

					if (self.isFiltersExpanded) {
						self.$filters.removeClass(
							"locationMap__filters--isExpanded"
						);

						$(this)
							.find('span[class*="icon-"]')
							.removeClass("icon-arrow_thin_left")
							.addClass("icon-arrow_thin_right");
					} else {
						self.$filters.addClass(
							"locationMap__filters--isExpanded"
						);

						$(this)
							.find('span[class*="icon-"]')
							.removeClass("icon-arrow_thin_right")
							.addClass("icon-arrow_thin_left");
					}
					self.isFiltersExpanded = !self.isFiltersExpanded;
				});
		},

		initZoomButtons: function() {
			var self = this;
			self.$element.find("[data-zoom-in]").on("click", function() {
				var zoom = self.map.getZoom();
				self.map.setZoom(zoom + 2);
			});
			self.$element.find("[data-zoom-out]").on("click", function() {
				var zoom = self.map.getZoom();
				if (zoom - 2 >= 0) {
					self.map.setZoom(zoom - 2);
				}
			});
		},

		getFilteredLocationsByCategories: function(categories) {
			return $.grep(this.activeMarkers, function(marker) {
				return $.inArray(marker.data.category, categories) > -1;
			});
		},

		getHiddenLocations: function(categories) {
			return $.grep(this.allMarkers, function(marker) {
				return $.inArray(marker.data.category, categories) === -1;
			});
		},

		updateMarkerClusterer: function(markers) {
			this.markerClusterer.clearMarkers();
			this.markerClusterer.addMarkers(markers);
			this.bounds = new google.maps.LatLngBounds();
		},

		extendMapBound: function(locations) {
			var self = this;
			$.each(locations, function() {
				var latlng = new google.maps.LatLng(
					this.lat || this.data.lat,
					this.lng || this.data.lng
				);
				if (!self.bounds.contains(latlng)) {
					self.bounds.extend(latlng);
				}
			});
		},

		markerOrClusterOnClick: function(marker) {
			if (this.activeMarker === marker) {
				return;
			}

			var self = this;

			if (self.infoWindow) {
				self.closeInfoWindow();
			}

			self.activeMarker = marker;

			var siblingMarkers = this.allMarkers.filter(function(
				siblingMarker
			) {
				return (
					siblingMarker.data.code !== marker.data.code &&
					siblingMarker.data.lat === marker.data.lat &&
					siblingMarker.data.lng === marker.data.lng
				);
			});

			if (Array.isArray(siblingMarkers) && siblingMarkers.length) {
				siblingMarkers.unshift(marker);
				marker.data.multipleMarkers = siblingMarkers;
				marker.data.options = self.options;
			}

			var renderedHtml = global.configuration.data.tpl.mapsMarkerPopup(
				marker.data
			);

			self.infoWindow = new google.maps.InfoWindow({
				content: renderedHtml
			});

			self.infoWindow.setContent(renderedHtml);

			if (marker.data.multipleMarkers) {
				google.maps.event.addListener(
					self.infoWindow,
					"closeclick",
					function() {
						self.mapClickListener = self.map.addListener(
							"click",
							function() {
								self.resetActiveMarker();
							}
						);
					}
				);
			}

			google.maps.event.addListener(
				self.infoWindow,
				"domready",
				function() {
					// Custom close btn
					var closeBtn = $("#iw-close-btn").get();
					google.maps.event.addDomListener(
						closeBtn[0],
						"click",
						function() {
							if (self.activeMarker) {
								self.closeInfoWindow();
							}
						}
					);

					var $tabs = self.$map.find(".tabs .tabs-navi");
					if ($tabs.length) {
						$tabs.tabs({
							inAnimation: "fadeIn",
							outAnimation: "fadeOut",
							speed: 250,
							activeClass: "current-tab",
							onInit: function() {
								var $slider = $tabs.closest("[data-swiper]");
								if ($slider.length > 0) {
									var $nextBtn = $slider.find(
										".swiper-button-next"
									);
									var $prevBtn = $slider.find(
										".swiper-button-prev"
									);

									var swiperConfig = {
										init: true,
										on: {
											init: function() {
												// Hide prev button initially
												$prevBtn.addClass("hidden");

												// Prevent unwanted behaviour such as resetActiveMarker() being called
												google.maps.event.removeListener(
													self.mapClickListener
												);
											},
											slideChange: function() {
												$prevBtn.toggleClass(
													"hidden",
													swiperInstance.isBeginning
												);
												$nextBtn.toggleClass(
													"hidden",
													swiperInstance.isEnd
												);
											}
										},
										navigation: {
											nextEl: $nextBtn.get(0),
											prevEl: $prevBtn.get(0)
										},
										autoplay: false,
										slidesPerView: 5,
										slidesPerGroup: 3,
										height: 30,
										autoHeight: false,
										threshold: 70,
										followFinger: false,
										hashNavigation: false,
										allowTouchMove: true,
										setWrapperSize: true
									};

									var swiperInstance = new Swiper(
										$slider.get(0),
										swiperConfig
									);
								}
							}
						});

						self.$map.addClass("has-tabs");
					}
				}
			);

			self.infoWindow.open(self.map, marker);
			self.infoWindow.setPosition(marker.position);

			self.activeMarker.infoWindowIsOpen = true;

			google.maps.event.addListener(
				self.infoWindow,
				"closeclick",
				function() {
					self.markerOnCloseClick(this, marker);
				}
			);
		},

		markerOnCloseClick: function(marker) {
			if (this.infoWindow) {
				this.closeInfoWindow();
			}
			marker.infoWindowIsOpen = false;
		},

		resetActiveMarker: function() {
			if (this.activeMarker) {
				this.closeInfoWindow();
				this.activeMarker = null;
			}
		},

		markersAreOnSamePosition: function(markers) {
			var firstPos = {
				lat: markers[0].data.lat,
				lng: markers[0].data.lng
			};

			return markers.every(function(marker) {
				return (
					marker.data.lat === firstPos.lat &&
					marker.data.lng === firstPos.lng
				);
			});
		},

		getOtherMarkerMarkersOnSamePositionCount: function(marker) {
			var locationsWithSamePosition = this.locations.filter(function(
				location
			) {
				return (
					location.lat === marker.lat && location.lng === marker.lng
				);
			});

			return locationsWithSamePosition.length;
		},

		removeMarkers: function() {
			var self = this;

			$.each(self.activeMarkers, function() {
				this.setMap(null);
			});

			self.activeMarkers = null;
			self.markerClusterer.clearMarkers();
			self.resetActiveMarker();
		},

		showMarkers: function(markers) {
			var self = this;

			$.each(markers, function() {
				this.setMap(self.map);
			});
		},

		getMarkerClusterImage: function() {
			return new google.maps.MarkerImage(
				this.options.markerImageCluster,
				null,
				null,
				null,
				new google.maps.Size(90, 90)
			);
			// null, null, null, new google.maps.Size(this.options.markerImageClusterSize, this.options.markerImageClusterSize));
		},

		getMarkerImage: function(marker) {
			if (marker.menuIcon === "mapmarker") {
				return new google.maps.MarkerImage(
					this.options.markerImage,
					null,
					null,
					null,
					new google.maps.Size(
						this.options.markerImageSize,
						this.options.markerImageSize
					)
				);
			} else if (marker.menuIcon === "bhkw") {
				return new google.maps.MarkerImage(
					this.options.markerImageBHKW,
					null,
					null,
					null,
					new google.maps.Size(
						this.options.markerImageSize,
						this.options.markerImageSize
					)
				);
			} else if (marker.menuIcon === "biene") {
				return new google.maps.MarkerImage(
					this.options.markerImageBiene,
					null,
					null,
					null,
					new google.maps.Size(
						this.options.markerImageSize,
						this.options.markerImageSize
					)
				);
			} else if (marker.menuIcon === "biogas") {
				return new google.maps.MarkerImage(
					this.options.markerImageBiogas,
					null,
					null,
					null,
					new google.maps.Size(
						this.options.markerImageSize,
						this.options.markerImageSize
					)
				);
			} else if (marker.menuIcon === "idea") {
				return new google.maps.MarkerImage(
					this.options.markerImageIdea,
					null,
					null,
					null,
					new google.maps.Size(
						this.options.markerImageSize,
						this.options.markerImageSize
					)
				);
			} else if (marker.menuIcon === "map-thin") {
				return new google.maps.MarkerImage(
					this.options.markerImageMapThin,
					null,
					null,
					null,
					new google.maps.Size(
						this.options.markerImageSize,
						this.options.markerImageSize
					)
				);
			} else if (marker.menuIcon === "solar") {
				return new google.maps.MarkerImage(
					this.options.markerImageSolar,
					null,
					null,
					null,
					new google.maps.Size(
						this.options.markerImageSize,
						this.options.markerImageSize
					)
				);
			} else if (marker.menuIcon === "smart-city") {
				return new google.maps.MarkerImage(
					this.options.markerImageSmartCity,
					null,
					null,
					null,
					new google.maps.Size(
						this.options.markerImageSize,
						this.options.markerImageSize
					)
				);
			} else if (marker.menuIcon === "wallbox") {
				return new google.maps.MarkerImage(
					this.options.markerImageWallbox,
					null,
					null,
					null,
					new google.maps.Size(
						this.options.markerImageSize,
						this.options.markerImageSize
					)
				);
			} else if (marker.menuIcon === "wasser") {
				return new google.maps.MarkerImage(
					this.options.markerImageWasser,
					null,
					null,
					null,
					new google.maps.Size(
						this.options.markerImageSize,
						this.options.markerImageSize
					)
				);
			} else if (marker.menuIcon === "wasserwerk") {
				return new google.maps.MarkerImage(
					this.options.markerImageWasserwerk,
					null,
					null,
					null,
					new google.maps.Size(
						this.options.markerImageSize,
						this.options.markerImageSize
					)
				);
			} else if (marker.menuIcon === "wind") {
				return new google.maps.MarkerImage(
					this.options.markerImageWind,
					null,
					null,
					null,
					new google.maps.Size(
						this.options.markerImageSize,
						this.options.markerImageSize
					)
				);
			} else if (marker.menuIcon === "wind-construction") {
				return new google.maps.MarkerImage(
					this.options.markerImageWindConstruction,
					null,
					null,
					null,
					new google.maps.Size(
						this.options.markerImageSize,
						this.options.markerImageSize
					)
				);
			} else if (marker.menuIcon === "wind-planning") {
				return new google.maps.MarkerImage(
					this.options.markerImageWindPlanning,
					null,
					null,
					null,
					new google.maps.Size(
						this.options.markerImageSize,
						this.options.markerImageSize
					)
				);
			}
		},

		addMarkers: function(markersData) {
			var self = this;
			var positionCache = [];

			$.each(this.locations, function() {
				var _self = this;
				var hitIndex = positionCache.findIndex(function(p) {
					return (
						p.lat === _self.position.lat &&
						p.lng === _self.position.lng
					);
				});
				var otherMarkersOnSamePositionCount = self.getOtherMarkerMarkersOnSamePositionCount(
					_self
				);
				var markerLabel =
					otherMarkersOnSamePositionCount > 1
						? {
								text: String(otherMarkersOnSamePositionCount),
								// color: self.options.clusterColor, // TODO: Use custom theme color, but targeting it over CSS is not possible
								fontSize: "14px"
						  }
						: null;
				var marker = new google.maps.Marker({
					position: _self.position,
					map: self.map,
					label: markerLabel,
					icon:
						otherMarkersOnSamePositionCount > 1
							? self.getMarkerClusterImage()
							: self.getMarkerImage(_self)
				});

				self.allMarkers.push(marker);

				if (hitIndex > -1) {
					marker.setVisible(false);
				}

				marker.data = _self;

				marker.addListener("click", function() {
					self.markerOrClusterOnClick(marker);
				});

				positionCache.push(_self.position);
			});

			self.activeMarkers = self.allMarkers;
			self.activeMarkers = self.getFilteredLocationsByCategories(
				self.getActiveCategoryNames()
			);
			self.hiddenMarkers = self.getHiddenLocations(
				self.getActiveCategoryNames()
			);

			$.each(self.hiddenMarkers, function() {
				this.setMap(null);
			});

			self.extendMapBound(self.activeMarkers);

			self.map.fitBounds(self.bounds);

			if (self.activeMarker) {
				self.closeInfoWindow();
			}

			var clusterStyles = [
				{
					textSize: "18",
					url: self.options.clusterImage,
					height: self.options.clusterImageSize,
					width: self.options.clusterImageSize
				},
				{
					textSize: "18",
					url: self.options.clusterImage,
					height: self.options.clusterImageSize,
					width: self.options.clusterImageSize
				},
				{
					textSize: "18",
					url: self.options.clusterImage,
					height: self.options.clusterImageSize,
					width: self.options.clusterImageSize
				}
			];

			var options = {
				imagePath: self.options.clusterImage,
				styles: clusterStyles,
				maxZoom: self.options.maxZoom - 1,
				zoomOnClick: false // we are using our own click handler logic
			};

			self.markerClusterer = new MarkerClusterer(
				self.map,
				self.activeMarkers,
				options
			);
		},

		closeInfoWindow: function() {
			this.infoWindow.close();
			this.infoWindow = null;

			this.$map.removeClass("has-tabs");

			if (this.activeMarker) {
				this.activeMarker = null;
			}
		},

		initSearchBarAutocomplete: function() {
			var self = this;

			self.searchInput = self.$element.find("[data-search-input]").get(0);
			self.searchBox = new google.maps.places.SearchBox(self.searchInput);

			self.map.addListener("bounds_changed", function() {
				self.searchBox.setBounds(self.map.getBounds());
			});

			var markers = [];
			self.searchBox.addListener("places_changed", function() {
				var places = self.searchBox.getPlaces();

				if (places.length === 0) {
					return;
				}

				markers.forEach(function(marker) {
					marker.setMap(null);
				});
				markers = [];

				var bounds = new google.maps.LatLngBounds();
				places.forEach(function(place) {
					if (!place.geometry) {
						return;
					}

					var icon = {
						url: place.icon,
						size: new google.maps.Size(71, 71),
						origin: new google.maps.Point(0, 0),
						anchor: new google.maps.Point(17, 34),
						scaledSize: new google.maps.Size(25, 25)
					};

					markers.push(
						new google.maps.Marker({
							map: self.map,
							icon: icon,
							title: place.name,
							position: place.geometry.location,
							visible: false
						})
					);

					if (place.geometry.viewport) {
						bounds.union(place.geometry.viewport);
					} else {
						bounds.extend(place.geometry.location);
					}
				});
				self.map.fitBounds(bounds);
			});
		}
	};

	$.extend(Plugin.prototype, methods);

	$.fn[pluginName] = function(options) {
		this.each(function() {
			if (!$.data(this, "plugin_" + pluginName)) {
				$.data(this, "plugin_" + pluginName, new Plugin(this, options));
			}
		});

		return this;
	};
})(jQuery, window, document);
